let goodstone = {

    init: function () {
        // this.register_plugin();
        // this.gsap_config();
        // this.lenis_with_scrolltrigger();
        this.slick_carousel();
        this.accordion();
        this.send_ring_sizer();
    },
    register_plugin: () => {
        gsap.registerPlugin(ScrollTrigger);
    },
    gsap_config: () => {
        gsap.config({
            trialWarn: false,
            ease: 'power1.inOut'
        });
    },
    lenis_with_scrolltrigger: () => {
        const lenis = new Lenis();
        lenis.on('scroll', (e) => {
            ScrollTrigger.update;
        });
        gsap.ticker.add((time) => {
            lenis.raf(time * 1000);
        })
        gsap.ticker.lagSmoothing(0);
        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }
        requestAnimationFrame(raf);
    },
    register_custom_component: function () {
        class SlickSlider extends HTMLElement {
            constructor() {
                super();
            }
        };
        customElements.define('slick-slider', SlickSlider);
    },
    slick_carousel: function () {
         $(document).ready(function() {
            var $announcements = $('[data-slider="announcements"]');
            var announcementsContent = $announcements.html();
            
            // Duplicate the announcements to ensure seamless looping
            $announcements.append(announcementsContent);
        
            $announcements.slick({
                arrows: false,
                dots: false,
                variableWidth: true,
                autoplay: true,
                autoplaySpeed: 0,
                speed: 10000,
                cssEase: 'linear',
                infinite: true,
                pauseOnHover: false
            });
        });


        let related_products_slider = $('[data-slider="related-products"]');
        related_products_slider.slick({
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev"><p class="sr-only">Previous</p><svg width="19" height="17"><use href="#icon--slider-arrow" /></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><p class="sr-only">Previous</p><svg width="19" height="17"><use href="#icon--slider-arrow" /></svg></button>',
            dots: true,
            autoplay: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: false,
            draggable: false,
            appendArrows: $('.nav--related-products'),
            appendDots: $('.nav--related-products'),
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        centerMode: true,
                        centerPadding: '14rem',
                    }
                }
            ]
        });

      let shapes_slider = $('[data-slider="shop-by-shape"]');
      shapes_slider.slick({
            arrows: false,
            dots: false,
            autoplay: false,
            // variableWidth: true,
            slidesToShow: 10,
            slidesToScroll: 1,
            infinite: false,
            responsive: [
              {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 6,
                      swipeToSlide: true
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 5,
                      swipeToSlide: true
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                      swipeToSlide: true
                    }
                }
            ]
        });
    },
    tabs: function () {
        $('[data-tabination="detailed-specs"]').responsiveTabs({
            startCollapsed: 'accordion'
        });
    },
    accordion: function () {
        $('.accordion__item').each(function () {
            if ($(this).hasClass('active')) {
                $(this).find('.accordion__body').slideToggle();
            }
        });
        $('.accordion__head').on('click', function () {
            let accordion_item_active = $(this).parent('.accordion__item').hasClass('active');
            console.log(accordion_item_active);
            if (accordion_item_active) {
                $(this).siblings('.accordion__body').slideToggle();
                $(this).parent('.accordion__item').toggleClass('active');
            }
            else {
                $(this).parent('.accordion__item').siblings().removeClass('active');
                $(this).parent('.accordion__item').siblings().find('.accordion__body').slideUp();
                $(this).siblings('.accordion__body').slideToggle();
                $(this).parent('.accordion__item').toggleClass('active');
            }

        });
    },
    send_ring_sizer: function () { 
        $('#send-ring-sizer').click(function(){
            $('.selector--size').val('Send ring sizer');
        });
    }
}

$(document).ready(function () {
    goodstone.init();
});